import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DynamicTitle = _resolveComponent("DynamicTitle")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_BlacklistUpsetDialog = _resolveComponent("BlacklistUpsetDialog")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DynamicTitle, {
      elements: [{ name: 'Blacklist', selected: true }],
      title: "Configuration"
    }),
    _createVNode(_component_v_data_table_server, {
      headers: _ctx.headers,
      items: _ctx.paginationData.items,
      "items-per-page-options": [10, 20, 50],
      "items-per-page": _ctx.itemsPerPage,
      "onUpdate:itemsPerPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemsPerPage) = $event)),
      page: _ctx.page,
      "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page) = $event)),
      "sort-by": _ctx.sortBy,
      "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sortBy) = $event)),
      loading: _ctx.isLoading,
      "items-length": _ctx.paginationData.totalCount,
      "onUpdate:options": _ctx.getDataFromApi
    }, {
      "item.email": _withCtx(({ item }) => [
        _createElementVNode("div", null, _toDisplayString(item.email), 1)
      ]),
      "item.firstName": _withCtx(({ item }) => [
        _createElementVNode("div", null, _toDisplayString(item.firstName), 1)
      ]),
      "item.lastName": _withCtx(({ item }) => [
        _createElementVNode("div", null, _toDisplayString(item.lastName), 1)
      ]),
      "item.lastModifiedDateTime": _withCtx(({ item }) => [
        _createElementVNode("div", null, _toDisplayString(item.lastModifiedDateTime
                            ? _ctx.getFormattedDateString(
                                  item.lastModifiedDateTime,
                                  true
                              )
                            : ""), 1)
      ]),
      "item.actions": _withCtx(({ item }) => [
        _createElementVNode("div", null, [
          _createVNode(_component_v_btn, {
            variant: "plain",
            icon: "mdi-pencil",
            class: "mr-2",
            onClick: ($event: any) => (_ctx.editItem(item))
          }, null, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            variant: "plain",
            icon: "mdi-delete",
            onClick: ($event: any) => (_ctx.deleteItem(item))
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["headers", "items", "items-per-page", "page", "sort-by", "loading", "items-length", "onUpdate:options"]),
    _createVNode(_component_v_btn, {
      color: "primary",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createDialog = true))
    }, {
      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
        _createTextVNode(" Add new entry ", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_BlacklistUpsetDialog, {
      "blacklist-entry-id": _ctx.selectedItemId,
      visible: _ctx.updateDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.updateDialog) = $event)),
      onCancel: _ctx.cancel
    }, null, 8, ["blacklist-entry-id", "visible", "onCancel"]),
    _createVNode(_component_BlacklistUpsetDialog, {
      visible: _ctx.createDialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.createDialog) = $event)),
      onCancel: _ctx.cancel
    }, null, 8, ["visible", "onCancel"]),
    _createVNode(_component_ConfirmationDialog, {
      visible: _ctx.deleteDialog,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.deleteDialog) = $event)),
      title: "Delete blacklist entry",
      onConfirm: _ctx.confirmDeleteBlacklist
    }, null, 8, ["visible", "onConfirm"])
  ]))
}